import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
   admin: boolean = false;
   productionMode: boolean;

}

